import { fabric } from 'fabric';

const MIN_CONTROL_SIZE = 8;
const MAX_CONTROL_SIZE = 20;
const ANIMATION_DURATION = 125;

export interface AnimationCallbacks {
  onRequestRender?: () => void;
  onComplete?: () => void;
}

export class ShapeConnectControlAnimator {
  isAnimating = false;
  currentSize: number;

  constructor(
    public minSize: number = MIN_CONTROL_SIZE,
    public maxSize: number = MAX_CONTROL_SIZE,
    public animationDuration: number = ANIMATION_DURATION
  ) {
    this.currentSize = this.minSize;
  }

  get atMaxSize(): boolean {
    return this.currentSize === this.maxSize;
  }

  setMaxSize() {
    this.currentSize = this.maxSize;
  }

  animate(state: 'enter' | 'exit', callbacks: AnimationCallbacks = {}): void {
    if (this.isAnimating) {
      this.isAnimating = false;
    }

    let duration = 0;
    const startValue = this.currentSize;
    let endValue = this.currentSize;

    switch (state) {
      case 'enter':
        endValue = this.maxSize;
        duration = this.animationDuration * (this.minSize / this.currentSize);
        break;
      case 'exit':
        duration = this.animationDuration * (this.currentSize / this.maxSize);
        endValue = this.minSize;
        break;
      default:
        return;
    }

    fabric.util.animate({
      startValue,
      endValue,
      duration,
      onStart: () => {
        this.isAnimating = true;
      },
      onChange: (newSize: number) => {
        this.currentSize = newSize;
        callbacks.onRequestRender?.();
      },
      onComplete: () => {
        this.isAnimating = false;
        callbacks.onComplete?.();
      },
      abort: () => !this.isAnimating,
    });
  }

  stopAnimation(): void {
    this.isAnimating = false;
    this.currentSize = this.minSize;
  }
}
